// Scroll an element into view by moving ONLY its nearest scrolling ancestor.
// `scrollIntoView` also scrolls every outer box, which shifts the whole app
// frame when the element sits in a panel (the right panel's reader, a chat
// reply). An interaction-edge DOM effect; it decides nothing.

export { centerInScrollParent, scrollParentOf };

const scrollParentOf = (el: HTMLElement): HTMLElement | null => {
    const parent = el.parentElement;
    if (parent === null) return null;
    const { overflowY } = getComputedStyle(parent);
    return (overflowY === "auto" || overflowY === "scroll") &&
        parent.scrollHeight > parent.clientHeight
        ? parent
        : scrollParentOf(parent);
};

// Bring `el` to the middle of its scrolling ancestor (no-op when nothing
// scrolls).
const centerInScrollParent = (el: HTMLElement): void => {
    const scroller = scrollParentOf(el);
    if (scroller === null) return;
    const box = el.getBoundingClientRect();
    const view = scroller.getBoundingClientRect();
    scroller.scrollBy({
        top: box.top - view.top - (view.height - box.height) / 2,
        behavior: "smooth",
    });
};
